module.exports = __webpack_public_path__ + "img/legales.f7ff2728.jpg";